module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "TOC-CH-T"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c01"
    }
  }, [_vm._v("Sugarpaste")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('a', {
    attrs: {
      "href": "#/c02"
    }
  }, [_vm._v("Modelling")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Covering Cakes")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dowelling Cakes")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Have Your Cake and Eat It!")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rock Your Socks Off")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ladies' Night at the Pool")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Stuff")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stripper!")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey of a Bunny Girl")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bubble-icious")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calendar Girls")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/c14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOC-FBMHD"
  }, [_c('span', {
    attrs: {
      "href": "#/cop",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 57
// module chunks = 0